/**
 * nginx `location /aichat_api/` 와 동일한 베이스.
 * CRA는 REACT_APP_* 를 빌드 시 치환하므로, 미설정 시 번들에 undefined 가 들어가
 * `/undefined/llm` 요청이 나가는 것을 막기 위해 기본값을 둡니다.
 */
const raw = process.env.REACT_APP_API_URL;

export const API_BASE_URL: string =
  typeof raw === 'string' && raw.trim() !== '' ? raw.trim() : '/aichat_api';
